import { DATE_FORMATS } from "@/enums";
import { DatePicker, Space } from "antd";
import { arrayOf, bool, func, node, oneOfType, string } from "prop-types";

const { RangePicker } = DatePicker;

export const ViperRangePicker = ({
  id,
  value,
  showTime,
  disabled = false,
  onFocus,
  onChange,
  allowClear = false,
  allowEmpty,
  suffixIcon,
  renderExtraFooter,
}) => {
  const dateFormat = DATE_FORMATS.fourDigitYear;

  return (
    <Space>
      <RangePicker
        data-test-id={id}
        value={value}
        disabled={disabled}
        showTime={showTime}
        allowEmpty={allowEmpty}
        format={dateFormat}
        onFocus={onFocus}
        onChange={onChange}
        allowClear={allowClear}
        suffixIcon={suffixIcon}
        placeholder={[dateFormat, dateFormat]}
        renderExtraFooter={renderExtraFooter}
      />
    </Space>
  );
};

ViperRangePicker.propTypes = {
  id: string.isRequired,
  value: arrayOf(string),
  showTime: oneOfType([node, bool]),
  disabled: bool,
  onFocus: func,
  onChange: func,
  allowClear: bool,
  allowEmpty: arrayOf(bool),
  suffixIcon: node,
  renderExtraFooter: func,
};
